module.exports = __webpack_public_path__ + "static/Bitmap-23ac43db4af8d85123952e6f36da0634.png";